import { Columns } from '@shared/interfaces/table/column-config';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';

/**
 * DataHusStatus partial status cell
 * Shows available states and translations
 */
export const datahubPartial: Columns<any> = {
  title: 'meter.datahub',
  key: 'dataHubStatus',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    confirmed: { color: 'bg-green-500', label: 'enum.datahub.status.confirmed' },
    pending: { color: 'bg-yellow-500', label: 'enum.datahub.status.pending' },
    pendingJob: { color: 'bg-yellow-500', label: 'enum.datahub.status.pendingJob' },
    rejected: { color: 'bg-red-500', label: 'enum.datahub.status.rejected' },
    obsolete: { color: 'bg-red-500', label: 'enum.datahub.status.obsolete' },
    notapplicable: { color: 'bg-gray-200', label: 'enum.datahub.status.notapplicable' },
    notspecified: { color: 'bg-gray-200', label: 'enum.datahub.status.notspecified' },
  }
}
